import { defineStore } from 'pinia'
import { ref } from 'vue'

type NotificationType = 'success' | 'error' | 'warning' | 'info'

interface NotificationOptions {
  message: string
  type: NotificationType
  duration?: number
}

export const useNotificationStore = defineStore('notification', () => {
  const show = ref(false)
  const message = ref('')
  const type = ref<NotificationType>('info')
  let timer: number | null = null

  const showNotification = ({ message: msg, type: notificationType, duration = 3000 }: NotificationOptions) => {

    if (timer) {
      clearTimeout(timer)
      timer = null
    }

    message.value = msg
    type.value = notificationType
    show.value = true

    timer = window.setTimeout(() => {
      hideNotification()
    }, duration)
  }

  const hideNotification = () => {
    show.value = false
    if (timer) {
      clearTimeout(timer)
      timer = null
    }
  }

  const success = (msg: string, duration?: number) => {
    showNotification({ message: msg, type: 'success', duration })
  }

  const error = (msg: string, duration?: number) => {
    showNotification({ message: msg, type: 'error', duration })
  }

  const warning = (msg: string, duration?: number) => {
    showNotification({ message: msg, type: 'warning', duration })
  }

  const info = (msg: string, duration?: number) => {
    showNotification({ message: msg, type: 'info', duration })
  }

  return {
    show,
    message,
    type,
    showNotification,
    hideNotification,
    success,
    error,
    warning,
    info
  }
})